import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {APP_BASE_HREF} from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonSearchComponent } from './button-search/button-search.component';
import { DateSearchComponent } from './date-search/date-search.component';
import { SearchComponent } from './search/search.component';
import { SimpleComponent } from './simple/simple.component';
import { SoldeComponent } from './solde/solde.component';
import { ImgComponent } from './img/img.component';
import { PopUpInfoComponent } from './pop-up-info/pop-up-info.component';
import {AngularFireModule} from '@angular/fire'; 
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    ButtonSearchComponent,
    DateSearchComponent,
    SearchComponent,
    SimpleComponent,
    SoldeComponent,
    ImgComponent,
    PopUpInfoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    ModalModule.forRoot(),
    FormsModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue : '/' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
